import { IItemCache } from '@ms/items-view/lib/private/models/IItemCacheObserver';
import { itemsBreadcrumbBetaControl } from '@ms/items-view/lib/private/controls/itemsBreadcrumbBetaControl';
import { IItemCacheThunkAction } from '@ms/items-view/lib/private/store/actions/ItemCacheActions';
import { spItemKeyFacet, spFolderItemSetKeyFacet } from '../../dataSource/Keys';
import { IControlHandler, createControlHandler } from '@ms/items-view/lib/private/addons/registerControlHandler';
import ListFilterUtilities from '@ms/odsp-datasources/lib/utilities/list/ListFilterUtilities';
import SPOFilesStrings from '../../dataSource/SPOFiles.resx';

export const itemsBreadcrumbBetaControlHandler: IControlHandler<typeof spItemKeyFacet.type, typeof itemsBreadcrumbBetaControl.type> =
  createControlHandler()(getControlHandler);

function getControlHandler(): IItemCacheThunkAction<typeof itemsBreadcrumbBetaControl.type> {
  return () => {
    return controlHandler;
  };
}

function controlHandler(
  itemCache: IItemCache,
  props: typeof itemsBreadcrumbBetaControl.inputType
): typeof itemsBreadcrumbBetaControl.returnType {
  return {
    leafItemKey: props.itemKey,
    crumbControlHandler: (itemCache2: IItemCache, props2: {
      itemKey: string;
    }) => {
      const spFolderItemSet = itemCache2.demandItemFacet(spFolderItemSetKeyFacet, props2.itemKey);

      if (spFolderItemSet) {
        const {
          filterParams
        } = spFolderItemSet;

        if (filterParams) {
          const filterList = ListFilterUtilities.getFilterList(filterParams, undefined, true);

          const filter = filterList[filterList.length - 1];

          const values = filter.values.map((filterVal: string) => filterVal || SPOFilesStrings.EmptyFilterOptionLabel);
          const displayName = ListFilterUtilities.formatBreadcrumbFilterValues(values, filter.type || '', {
            booleanFalse: SPOFilesStrings.booleanFalse,
            booleanTrue: SPOFilesStrings.booleanTrue
          });

          const parentItemKey = spFolderItemSetKeyFacet.serialize({
            ...spFolderItemSet,
            filterParams: ListFilterUtilities.addFilterInfo(filterParams, filter.fieldName, '', true) || undefined
          });

          return {
            displayName,
            parentItemKey
          };
        }
      }

      return {};
    }
  };
}
